<section class="video-section section">
    <div class="container">
        <div class="banner-text">
            <h2>
                <span>Tour at</span> Rahul Consultancy Services
            </h2>
            <img src="assets/icon/play-button.svg">
        </div>
    </div>
</section>